import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {Button, ButtonToolbar, Modal} from 'react-bootstrap'
import cx from 'classnames'
import {errorStatus} from '../../core/redux/status'
import {connectForm} from '../../core/redux/form'
import LoaderButton from '../../core/components/LoaderButton'
import PatrimonyPicker from '../../patrimony/components/PatrimonyPicker'
import {DOWNGRADE_EXECUTIVE_TO_PATRIMONY_MANAGER_CMD_UPDATED, sendDowngradeExecutiveToPatrimonyManagerCmd, loadUserStream} from '../actions'
import {DowngradeExecutiveToPatrimonyManagerCmd} from '../models'
import i18n from '../i18n'

class DowngradeExecutiveToPatrimonyManagerModal extends Component {

    static propTypes = {
        user: PropTypes.object.isRequired,
        onHide: PropTypes.func.isRequired
    }

    _sendCmd() {
        const {dispatch, user, onHide} = this.props
        
        return dispatch(sendDowngradeExecutiveToPatrimonyManagerCmd(user.uid)).then(() => {
            return dispatch(loadUserStream())
        }).then(() => {
            onHide()
        })
    }

    render() {
        const {dispatch, form, company, user, onHide, ...others} = this.props

        return (
            <Modal
                bsSize='large'
                onHide={onHide}
                {...others}>
                <Modal.Header>
                    <Modal.Title>{i18n.downgradeExecutiveToPatrimonyManager}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <PatrimonyPicker multi split
                        company={company}
                        {...form.managedPatrimonies()} />
                    <ButtonToolbar>
                        <LoaderButton
                            bsStyle='primary'
                            bsSize='large'
                            className={cx({disabled: !form.isValid()})}
                            onClick={() => form.validate() && this._sendCmd() || dispatch(errorStatus(i18n.formInvalid))}>
                            {i18n.save}
                        </LoaderButton>
                        <Button
                            bsSize='large'
                            onClick={onHide}>
                            {i18n.cancel}
                        </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        )
    }
}

DowngradeExecutiveToPatrimonyManagerModal = connectForm({
    target: 'cmd',
    schema: DowngradeExecutiveToPatrimonyManagerCmd.schema,
    action: DOWNGRADE_EXECUTIVE_TO_PATRIMONY_MANAGER_CMD_UPDATED
})(DowngradeExecutiveToPatrimonyManagerModal)

DowngradeExecutiveToPatrimonyManagerModal = connect((state) => ({
    company: state.company.company,
    cmd: state.company.downgradeExecutiveToPatrimonyManagerCmd
}))(DowngradeExecutiveToPatrimonyManagerModal)

export default DowngradeExecutiveToPatrimonyManagerModal


// WEBPACK FOOTER //
// ./lib/company/components/DowngradeExecutiveToPatrimonyManagerModal.js